import React, { useState, useEffect, useRef } from "react";
import CustomButton from "./CustomButton";
// import { fetchContent } from "../services/api";
import MenuScreen from "./MenuScreen";
import { error } from "jquery";
import DeleteProfile from "./DeleteProfile";
import AddProfile from "./AddProfile";
import MyProfile from "./MyProfile";
import selectedIcon from "../assets/selectedIcon.png";
import { Translate } from "./LanguageChanger";
import WhoAddProfile from "./WhoAddProfile";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import Wrapper from "./shared/Wrapper";
import ModalScreen from "./ModalScreen";
import logoutIcon from "../assets/Logout-Icon.png";

import backIcon from "../assets/back-button.png";
import { getUserProfile, updateUserProfile } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

const WhoWatching = ({ navigate }) => {
  const [selectedElementIndex, setSelectedElementIndex] = useState(0);
  const [confirmedSelection, setConfirmedSelection] = useState(null);
  const [screen, setScreen] = useState();
  // const [isBackButtonSelected, setIsBackButtonSelected] = useState(false);

  const [state, setState] = useState({
    isBackButtonSelected: false,
    isEditSelected: false,
    isDeleteSelected: false,
    shouldShowError: false, // Ensure all values have a default
    errTitle: "",
    errDescription: "",
    errIcon: null,
    iconWdth: "",
    iconHeight: "",
    button: ["Exit", "Cancel"],
  });

  useEffect(() => {
    // Matomo Event

    sendTestMatomoEvent({ eventCategory: "Login", eventAction: "Who'sWatching"  });
  }, []);

  // Now safely destructure the state
  const {
    isEditSelected,
    isDeleteSelected,
    isBackButtonSelected,
    shouldShowError,
    errTitle,
    errDescription,
    errIcon,
    iconWdth,
    iconHeight,
    button,
  } = state;

  console.log("window", window.clearTime); // Still 42

  // let user_details = localStorage.getItem("user_details");
  // const user_profile = JSON.parse(localStorage.getItem("user_details"));

  let user_details = JSON.parse(
    localStorage.getItem("user_details")
  )?.user_profiles;
  // const user_profile = JSON.parse(user_details);

  //   const updatedMyprofile = JSON.parse(localStorage.getItem("updateMyProfile")).data;

  //   const user_profile = updatedMyprofile ? updatedMyprofile : user_details;

  const updatedMyprofile = localStorage.getItem("updateMyProfile")
    ? JSON.parse(localStorage.getItem("updateMyProfile")).data
    : null;

  // If updatedMyprofile is available and has data, use it; otherwise, fall back to user_details
  const user_profile = updatedMyprofile ? updatedMyprofile : user_details;
  // console.log("user_profile...", user_profile);

  const [profiles, setProfiles] = useState(
    user_profile.map((profile) => ({
      name: profile.username,
      image: profile.profile,
      isKids: profile.is_kid,
      profileId: profile.profile_id,
      userId: profile.user_id,
    }))
  );

  const profileRefs = useRef([]);
  if (profileRefs.current.length !== profiles.length) {
  profileRefs.current = profiles.map(
    (_, i) => profileRefs.current[i] ?? React.createRef()
  );
  }

  const addProfileRef = useRef(null);
  const editButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);

  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    // setData(data);
    window.removeEventListener("keydown", WhoWatchingKeyHandler);
    // window.addEventListener("keydown", AddProfileKeyHandler);
  };

  useEffect(() => {
    clearInterval(window.clearTime);
  }, []);

  const modalOKButtonHandler = () => {
    if (window.tizen) {
      sendTestMatomoEvent({ eventCategory: "App" , eventAction: "End" });
      window.tizen.application.getCurrentApplication().exit();
    } else {
      sendTestMatomoEvent({ eventCategory: "App" , eventAction: "End" });
      window.close();
    }
  };

  const modalCANCELButtonHandler = () => {
    setSelectedElementIndex(0);
    // setIsBackButtonSelected(false);
    setState((prevState) => ({
      ...prevState,
      shouldShowError: false,
      isBackButtonSelected: false,
    }));
    window.addEventListener("keydown", WhoWatchingKeyHandler);
  };

  const WhoWatchingKeyHandler = (event) => {
    if (event.keyCode !== undefined) {
      switch (event.keyCode) {
        case 13: // Enter key
          if (isBackButtonSelected) {
            handleExit();
            return;
          }

          if (selectedElementIndex < profiles.length) {
            console.log(selectedElementIndex, profiles[selectedElementIndex]);
            localStorage.setItem(
              "myProfile",
              JSON.stringify(profiles[selectedElementIndex])
            );
            localStorage.setItem(
              "profileId",
              profiles[selectedElementIndex].profileId
            );
            localStorage.setItem(
              "userId",
              profiles[selectedElementIndex].userId
            );
            localStorage.setItem(
              "proImg",
              profiles[selectedElementIndex].image
            );


              sendTestMatomoEvent({
                eventCategory:"Profile",
                eventAction: "Select",
                eventName: `${profiles[selectedElementIndex].profileId}/${profiles[selectedElementIndex].name}/${profiles[selectedElementIndex].isKids == 0 ? "Adult" : "Child"}`
              })
            

            // Navigate to profile details or add profile
            // MenuScreen.ReseTfocus(4);
            navigate("HomePage");
          } else if (selectedElementIndex === profiles.length) {
            // console.log("who's watching add profile...");
            navigate("WhoAddProfile"); // Navigate to add profile page
          }
          // else if (selectedElementIndex === profiles.length + 1) {
          //   navigate("EditProfile");
          //   // Handle Edit Profile action
          // } else if (selectedElementIndex === profiles.length + 2) {
          //   // Handle Delete Profile action
          // }
          break;
        case 39: // Right arrow
          if (selectedElementIndex <= profiles.length - 1 && profiles.length !== 5) {
            setSelectedElementIndex((prevIndex) => prevIndex + 1);
          }else if( selectedElementIndex < profiles.length - 1){
            setSelectedElementIndex((prevIndex) => prevIndex + 1);
          }
          break;
        case 37: // Left arrow
          if (selectedElementIndex > 0) {
            setSelectedElementIndex((prevIndex) => prevIndex - 1);
          }
          break;
        case 38: // Up arrow
          // setSelectedElementIndex(null);
          // setIsBackButtonSelected(true);
          setState((prevState) => ({
            ...prevState,
            isBackButtonSelected: true,
          }));
          setSelectedElementIndex();
          // window.removeEventListener("keydown", WhoWatchingKeyHandler);
          // if (selectedElementIndex === profiles.length + 1) {
          //   addProfileRef.current.focus();
          //   setSelectedElementIndex(profiles.length);
          //   setState({ isEditSelected: false, isDeleteSelected: false });
          // } else if (selectedElementIndex === profiles.length + 2) {
          //   // editButtonRef.current.focus();
          //   setSelectedElementIndex(profiles.length + 1);
          //   setState({ isEditSelected: true, isDeleteSelected: false });
          // } else if (selectedElementIndex === profiles.length) {
          //   profileRefs.current[profiles.length - 1].current.focus();
          //   setSelectedElementIndex(profiles.length - 1);
          // }

          break;
        case 40: // Down arrow
          if (isBackButtonSelected) {
            setState((prevState) => ({
              ...prevState,
              isBackButtonSelected: false,
            }));
            setSelectedElementIndex(0);
            // setIsBackButtonSelected(false);
            window.addEventListener("keydown", WhoWatchingKeyHandler);
          }
          // if (selectedElementIndex < profiles.length) {
          //   profileRefs.current[selectedElementIndex].current.blur();
          //   setSelectedElementIndex(profiles.length + 1);
          //   setState({ isEditSelected: true, isDeleteSelected: false });
          // } else if (selectedElementIndex === profiles.length) {
          //   addProfileRef.current.blur();
          //   setSelectedElementIndex(profiles.length + 1);
          //   setState({ isEditSelected: true, isDeleteSelected: false });
          // } else if (selectedElementIndex === profiles.length + 1) {
          //   setState({ isEditSelected: false, isDeleteSelected: true });
          //   setSelectedElementIndex(profiles.length + 2);
          // }
          break;
        default:
          break;
      }
    }
    if (
      event.keyCode === 461 ||
      event.keyCode === 8 ||
      event.keyCode === 10009
    ) {
      console.log("Do Something");
      handleExit();
    }
  };

  const handleExit = () => {
    window.removeEventListener("keydown", WhoWatchingKeyHandler);
    // setSelectedElementIndex(0);
    setState((prevState) => ({
      ...prevState,
      shouldShowError: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Exit", "Cancel"],
    }));
    // MenuScreen.SetFocus(true);
  };

  const navigateHome = () => {
    if (selectedElementIndex < profiles.length) {
      localStorage.setItem(
        "profileId",
        profiles[selectedElementIndex].profileId
      );
      console.log("userId", profiles[selectedElementIndex].userId);
      localStorage.setItem("userId", profiles[selectedElementIndex].userId);
      navigate("HomePage");
    } else if (selectedElementIndex === profiles.length) {
      // console.log("who's watching add profile...");
      navigate("WhoAddProfile"); // Navigate to add profile page
    }
  };

  const updateloadData = async () => {
    // const userId = profiles.profileId;
    const userId = localStorage.getItem("userID");
    const getCountry = localStorage.getItem("country");
    let myHeaders = {
      platform: "0",
      iskid: "0",
      age: "12",
      country: getCountry,
      Langid: "1",
      timestamp: "0000000000",
      // profileid: user_details["user_profiles"][selectedElementIndex]["profile_id"],
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };

    try {
      // const [response] = await Promise.all([
      //   fetchContent(
      //     `/V1/getUserProfile/lastupdated/0000000000/userId/${userId}`,
      //     "GET",
      //     myHeaders
      //   ),
      // ]);

      const response = await getUserProfile(userId);

      localStorage.setItem("updateMyProfile", JSON.stringify(response));

      if (response.statusCode === 200) {
        // console.log("updatedMyProfile...", response)
        // MenuScreen.ReseTfocus(-1);
        // setState((prevState) => ({
        //   ...prevState,
        //   updateData: response.data,
        //   shouldShowModal: false
        // }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //   state.isBackButtonSelected = false;
  //   if (
  //     selectedElementIndex < profiles.length &&
  //     profileRefs.current[selectedElementIndex].current
  //   ) {
  //     profileRefs.current[selectedElementIndex].current.focus();
  //   } else if (
  //     selectedElementIndex === profiles.length &&
  //     addProfileRef.current
  //   ) {
  //     addProfileRef.current.focus();
  //   }
  //   // else if (
  //   //   selectedElementIndex === profiles.length + 1 &&
  //   //   editButtonRef.current
  //   // ) {
  //   //   editButtonRef.current.focus();
  //   // } else if (
  //   //   selectedElementIndex === profiles.length + 2 &&
  //   //   deleteButtonRef.current
  //   // ) {
  //   //   deleteButtonRef.current.focus();
  //   // }
  // }, [selectedElementIndex]);

  useEffect(() => {
    updateloadData();
  }, []); // Empty array ka matlab: Component mount hone par sirf ek baar run karo

  // 2. Ye wala useEffect buttons/keys handle karne ke liye hai
  useEffect(() => {
    // Listener add karo
    window.addEventListener("keydown", WhoWatchingKeyHandler);
    
    // Cleanup function (purana listener hatane ke liye)
    return () => {
      window.removeEventListener("keydown", WhoWatchingKeyHandler);
    };
  }, [selectedElementIndex, isBackButtonSelected]);

  const loadData = async () => {
    // const myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json");
    // myHeaders.append(
    //   "Authorization",
    //   `Bearer ${localStorage.getItem("JWTToken")}`
    // );

    let myHeaders = {
      // platform: "0",
      // iskid: "0",
      // age: "12",
      // country_name: "India",
      // Langid: "1",
      //
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };

    const raw = {
      profile_id: "",
      activity: 1,
      username: "Usernsme",
      profile: "profile",
      is_kid: 0,
    };

    let body = JSON.stringify(raw);

    try {
      // const [response] = await Promise.all([
      //   fetchContent("/V1/updateUserProfile", "POST", myHeaders, body),
      // ]);

      const response = await updateUserProfile(body);

      // console.log(response);

      if (response.status === true) {
        // updateloadData();
      } else {
        console.log("error", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //   loadData();
  // }, []);

  const addProfile = () => {
    if (profiles.length < 5) {
      setProfiles([
        ...profiles,
        {
          name: "New Profile",
          image: "https://via.placeholder.com/100",
          isKids: false,
        },
      ]);
    }
  };

  const addProfileButton = () => {
    navigate("WhoAddProfile");
  };

  const styles = {
    container: {
      backgroundImage: `url(${solidbackgroundimg})`,
      textAlign: "center",
      color: "white",
      backgroundColor: "#0E1653",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundSize: "cover",  
      backgroundRepeat: "no-repeat",
      gap:"100px",
    },
    profilesContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
     

    },
    profileCard: {
      backgroundColor: "#0E1653",
      borderRadius: "10px",
      // padding: "10px",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // border: "2px solid white",
      width: "151px",
      height: "151px",
    },
    profileName: {
      marginTop: "15px",
      position: "relative",
      // top: "10rem",
      // right: "7rem",
    },
    kidsBadge: {
      backgroundColor: "#ffcc00",
      borderRadius: "5rem",
      padding: "2px 5px",
      // marginLeft: "5px",
      position: "relative",
      bottom: "4rem",
      width: "5rem",
      left: "2rem",
    },
    addProfile: {
      backgroundColor: "#0E1653",
      justifyContent: "center",
    },
    addProfileIcon: {
      fontSize: "50px",
    },
    focusStyle: {
      outline: "5px solid rgba(255, 255, 255, 1)",
    },
    buttonStyle: {
      backgroundColor: "orange",
      border: "none",
      padding: "10px 20px",
      margin: "5px",
      borderRadius: "5px",
      cursor: "pointer",
      outline: "none",
    },
    deleteButtonStyle: {
      backgroundColor: "#ff4040",
    },
  };

  if (screen === "WhoAddProfile") {
    // console.log("move to myprofile page to deleteprofile page....");
    window.removeEventListener("keydown", WhoWatchingKeyHandler);
    return <WhoAddProfile navigate={navigateToScreen} />;
  }

  return (
    console.log("who's watching screen..."),
    (
      <div style={styles.container}>
        {/* <div
          style={{
            position: "absolute",
            top: "1.6rem",
            zIndex: 100,
            left: 0,
          }}
        >
          <Wrapper
            as="button"
            style={{
              backgroundColor: "transparent",
              border: "none",
              marginLeft: "2rem",
              borderRadius: "1rem",
              aspectRatio: "1/1",
              cursor: "pointer",
              outline: isBackButtonSelected
                ? "4px solid rgba(255, 255, 255, 1)"
                : "none",
            }}
            onClick={(e) => {
              handleExit();
            }}
           onMouseEnter={() => {
              setState((prevState) => ({
                ...prevState,
                isBackButtonSelected: true,
              }));
              setSelectedElementIndex(null);
            }}
          >
            <img src={backIcon} width={50} height={50} />
          </Wrapper>
        </div> */}
        <h1
          style={{
            fontFamily: "Anek Latin",
            fontWeight: 500,
            fontSize: "32px",
         
            color: "rgba(255, 255, 255, 1)",
          }}
        >
          <Translate langKey={"who_s_watching"} />
          &nbsp;?
        </h1>
        <div style={styles.profilesContainer}>
          {profiles.map((profile, index) => (
            <div key={index}>
              <Wrapper
                style={
                  selectedElementIndex === index
                    ? { ...styles.profileCard, ...styles.focusStyle }
                    : styles.profileCard
                }
                tabIndex={0}
                ref={profileRefs.current[index]}
                id={`profile_${index}`}
                onMouseEnter={() => {
                setSelectedElementIndex(index);
                setState(prev => ({...prev, isBackButtonSelected: false}));
              }}
                onClick={(e) => {
                  setSelectedElementIndex(index);
                  localStorage.setItem("myProfile", JSON.stringify(profile));
                  setConfirmedSelection(index);
                  navigateHome();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    console.log("who's watching.....");
                    setSelectedElementIndex(index);
                    localStorage.setItem("myProfile", JSON.stringify(profile));
                    setConfirmedSelection(index);
                  }
                }}
              >
                <img
                  src={profile.image}
                  alt={profile.name}
                  style={{
                    width: "151px",
                    height: "151px",
                    borderRadius: "10px",
                  }}
                  // onKeyDown={(e) => {
                  //   if (e.key === "Enter") {
                  //     console.log("who's watching.....");
                  //     setSelectedElementIndex(index);
                  //     localStorage.setItem(
                  //       "selectedAddProfile",
                  //       JSON.stringify(profile)
                  //     );
                  //     setConfirmedSelection(index);
                  //   }
                  // }}
                />
                {confirmedSelection === index && (
                  <img
                    src={selectedIcon} // Replace with the actual path to your checkmark icon
                    alt="Selected"
                    style={styles.selectedIcon}
                  />
                )}
              </Wrapper>
              <div style={styles.profileName}>
                {profile.name.length > 10
                  ? profile.name.slice(0, 10) + "..."
                  : profile.name}
                {profile.isKids === 1 && <h3 style={styles.kidsBadge}>KIDS</h3>}
              </div>
            </div>
          ))}
          {profiles.length < 5 && (
            <Wrapper
              style={
                selectedElementIndex === profiles.length
                  ? {
                      ...styles.profileCard,
                      ...styles.addProfile,
                      ...styles.focusStyle,
                    }
                  : { ...styles.profileCard, ...styles.addProfile }
              }
              onMouseEnter={() => {
                setSelectedElementIndex(profiles.length);
                setState(prev => ({...prev, isBackButtonSelected: false}));
              }}
              onClick={addProfileButton}
              ref={addProfileRef}
              tabIndex={0}
            >
              <div style={styles.addProfileIcon}>+</div>
              <div style={styles.profileName}>Add Profile</div>
            </Wrapper>
          )}
        </div>
        <div style={{ marginTop: "20px" }}>
          {/* <div>
          <CustomButton
            ref={editButtonRef}
            navigateTo="/login"
            fontSize="24px"
            defaultSelected={isEditSelected}
            width="22vw"
            height="7vh"
            top="6vh"
            left="0vw"
            position="relative"
            onClick={() => console.log("Edit Profile clicked")}
            onKeyDown={MyProfileKeyHandler}
          >
            Edit Profile
          </CustomButton>
        </div> */}
          <div>
            {/* <CustomButton
            ref={deleteButtonRef}
            navigateTo="/login"
            fontSize="24px"
            defaultSelected={isDeleteSelected}
            width="22vw"
            height="7vh"
            top="2vh"
            left="0vw"
            position="relative"
            onClick={() => console.log("Delete Profile clicked")}
            onKeyDown={MyProfileKeyHandler}
          >
            Delete Profile
          </CustomButton> */}
          </div>
        </div>
        <ModalScreen
          shouldShowError={shouldShowError}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
      </div>
    )
  );
};

export default WhoWatching;
